<div class="image-puzzle-win-screen">
  <ion-grid style="display: flex; flex-direction: column">
    <ion-row>
      <ion-text class="image-puzzle-message">{{ translationKey + ".win_dialog.text" |  translate:{ duration: duration, moveCounter: moveCounter } }}</ion-text>
    </ion-row>
    <ion-row>
      <ion-text class="image-puzzle-description" [innerHTML]="data.description"></ion-text>
    </ion-row>
    <ion-row class="win-screen-preview-row">
      <div class="win-screen-preview">
        <lib-app-image-puzzle-preview
          [rows]="data.rows"
          [columns]="data.columns"
          [height]="data.height"
          [width]="data.width"
          [copyright]="copyright"
          [tileImages]="data.tileImages">
        </lib-app-image-puzzle-preview>
      </div>
    </ion-row>
  </ion-grid>


<!--  <div class="image-puzzle-copyright">© {{copyright}}</div>-->
</div>
